import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
    getChallenge,
    getTopContributors,
    getContributorsLoading,
} from '../selectors';
import { topContributorsRequested } from '../actions';
import { DROPDOWNDATA } from './constants';
import TopContributorsCard from '../../../common/TopContributorsCard';

function TopContributors({
    onLoad,
    topContributors,
    contributorsLoading,
    challenge,
}) {
    useEffect(() => {
        onLoad(DROPDOWNDATA[0].key);
    }, []);

    useEffect(() => {
        if (challenge) onLoad(DROPDOWNDATA[0].key);
    }, [challenge]);

    return (
        <TopContributorsCard
            topContributors={topContributors}
            loading={contributorsLoading}
            onSelect={onLoad}
            className="d-flex flex-column"
        />
    );
}

TopContributors.propTypes = {
    challenge: PropTypes.object,
    // function to be called when component is initialized
    onLoad: PropTypes.func.isRequired,
    // contributors to be listed in component
    topContributors: PropTypes.arrayOf(PropTypes.object).isRequired,
    // boolean value to determine whether to show the loader
    contributorsLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        challenge: getChallenge(state),
        topContributors: getTopContributors(state),
        contributorsLoading: getContributorsLoading(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLoad: (date, customDate) =>
            dispatch(topContributorsRequested(date, customDate)),
    };
};

const ConnectedTopContributors = connect(
    mapStateToProps,
    mapDispatchToProps,
)(TopContributors);

export default ConnectedTopContributors;
